// Codec for the ROP backend's TypeSchedule.value field: a 168-character
// string of '0'/'1' chars. index 0-23 = Sunday hours 00-23, 24-47 = Monday,
// ... 144-167 = Saturday (7 days x 24 hours, day-major ordering starting
// Sunday). Shared by both the FTP schedule and the recording schedule.

const DAYS = 7;
const HOURS = 24;
const LENGTH = DAYS * HOURS;

export const scheduleStringToGrid = (value) => {
  const grid = Array.from({ length: DAYS }, () => Array(HOURS).fill(false));
  if (typeof value !== 'string' || value.length !== LENGTH) {
    return grid;
  }
  for (let day = 0; day < DAYS; day++) {
    for (let hour = 0; hour < HOURS; hour++) {
      grid[day][hour] = value[day * HOURS + hour] === '1';
    }
  }
  return grid;
};

export const gridToScheduleString = (grid) => {
  let value = '';
  for (let day = 0; day < DAYS; day++) {
    for (let hour = 0; hour < HOURS; hour++) {
      value += grid?.[day]?.[hour] ? '1' : '0';
    }
  }
  return value;
};
